module.exports = __webpack_public_path__ + "static/media/screenshot_bookmark-organizer.c7aa5e10.png";